import http from '../01_axios'
import type { ApiResponse } from '../01_axios/api/response.api'
import * as urls from './components/urls'

const getSystemKey = (): Promise<ApiResponse<any>> => http.get(urls.apiGetSystemKey)

const CommonService = {
  getSystemKey,
}

export default CommonService
